import { useData } from "@providers/context";

export const userInternalRoleCheck = (interRolePermit: string[]): boolean => {
  const { currentRole } = useData();
  if (currentRole && interRolePermit?.includes(currentRole)) {
    return true;
  }

  return false;
};

// export const multipleInternalRoleCheck = (interRolePermits: any) => {
//   const check = interRolePermits?.map((val: string) =>
//     userInternalRoleCheck(val)
//   );
//   let result = false;

//   for (let i = 0; i < check?.length; i++) {
//     result = result || check[i];
//     if (result === true) {
//       break; // Short-circuit if result is already true
//     }
//   }

//   return result;
// };
